// extracted by mini-css-extract-plugin
module.exports = {"root":"az_gk","marginNormal":"az_hk","marginDense":"az_ik","fullWidth":"az_jk"};